import { render, staticRenderFns } from "./EsMegaMenu.vue?vue&type=template&id=252a47fe"
import script from "./EsMegaMenu.vue?vue&type=script&lang=js"
export * from "./EsMegaMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports